import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { GlobalHeader, GlobalFooter } from "@/pages/GlobalLanding";
import Landing from "@/pages/Landing";
import EventGallery from "@/pages/EventGallery";
import { MapPin, Phone, ExternalLink } from "lucide-react";
import { HorizontalPostCarousel } from "@/components/posts/PublicPosts";

function CampusNews({ schoolId }) {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    if (!schoolId) return;
    api.get(`/posts/public?entity_id=${schoolId}&limit=8`)
      .then((r) => setPosts(r.data || [])).catch(() => {});
  }, [schoolId]);
  return (
    <div data-testid="campus-news">
      <HorizontalPostCarousel title="Campus News & Bulletins" subtitle="Straight from the school"
        themeColor="blue" posts={posts} testid="campus-posts-carousel" />
    </div>
  );
}

export default function SchoolLanding() {
  const { slug } = useParams();
  const [school, setSchool] = useState(null);
  useEffect(()=>{
    api.get("/global/schools/public").then(r=>{
      setSchool(r.data.find(s=>s.slug===slug) || null);
    });
  }, [slug]);
  return (
    <div className="min-h-screen">
      <GlobalHeader/>
      {school && (
        <div className="border-b-2 border-black bg-[#C4B5FD]">
          <div className="max-w-7xl mx-auto px-6 py-6 grid md:grid-cols-3 gap-4 items-center">
            <div className="md:col-span-2">
              <div className="nb-label">PARTNER SCHOOL</div>
              <h1 className="display text-3xl font-black">{school.name}</h1>
              <div className="text-sm mt-1 flex flex-wrap gap-4">
                <span className="flex items-center gap-1"><MapPin size={14}/>{school.address}</span>
                <span className="flex items-center gap-1"><Phone size={14}/>{school.phone}</span>
                {school.domain && (
                  <a href={`https://${school.domain}`} target="_blank" rel="noreferrer"
                     className="flex items-center gap-1 text-blue-700 underline"
                     data-testid={`school-domain-${slug}`}>
                    <ExternalLink size={14}/>{school.domain}
                  </a>
                )}
              </div>
            </div>
            {school.hero_image_url && <img src={school.hero_image_url} alt={school.name} className="w-full h-32 object-cover border-2 border-black rounded shadow-[4px_4px_0_0_#000]"/>}
          </div>
        </div>
      )}
      <EventGallery slug={slug}/>
      {school && <CampusNews schoolId={school.school_id} />}
      <Landing embedded/>
      <GlobalFooter/>
    </div>
  );
}
